(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["true-bundle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-true-bundle]').forEach((bundle) => {
    const payload = bundle.querySelector('[data-true-bundle-items]');
    const button = bundle.querySelector('[data-true-bundle-add]');
    const cards = [...bundle.querySelectorAll('[data-bundle-index]')];
    const status = bundle.querySelector('[data-true-bundle-status]');
    if (!payload || !button || cards.length !== 4) return;

    const products = JSON.parse(payload.textContent);
    let quantities = [1, 1, 1, 1];
    const presets = {
      mixed: [1, 1, 1, 1],
      dark: [2, 0, 2, 0],
      milk: [0, 2, 0, 2],
      flakes: [0, 0, 2, 2],
      clusters: [2, 2, 0, 0]
    };
    const formatter = new Intl.NumberFormat('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    });
    const formatMoney = (cents) => `${formatter.format(cents / 100)} ${bundle.dataset.currency || 'MXN'}`;

    const render = () => {
      const count = quantities.reduce((sum, quantity) => sum + quantity, 0);
      const subtotal = quantities.reduce((sum, quantity, index) => sum + quantity * products[index].price, 0);
      const qualifies = count >= 4;
      const total = qualifies ? Math.round(subtotal * 0.9) : subtotal;
      const savings = subtotal - total;

      cards.forEach((card, index) => {
        card.querySelector('[data-bundle-quantity]').textContent = quantities[index];
        const [minus, plus] = card.querySelectorAll('[data-bundle-delta]');
        minus.disabled = quantities[index] === 0;
        plus.disabled = !products[index].available;
      });

      bundle.querySelector('[data-bundle-count]').textContent = count;
      bundle.querySelector('[data-bundle-progress]').style.width = `${Math.min(100, count * 25)}%`;
      bundle.querySelector('[data-bundle-subtotal]').textContent = formatMoney(subtotal);
      bundle.querySelector('[data-bundle-total]').textContent = formatMoney(total);
      bundle.querySelector('[data-bundle-savings]').textContent = formatMoney(savings);
      button.disabled = !qualifies || products.some((product, index) => quantities[index] > 0 && !product.available);
      button.textContent = qualifies ? button.dataset.defaultLabel : button.dataset.incompleteLabel;
    };

    cards.forEach((card, index) => {
      card.querySelectorAll('[data-bundle-delta]').forEach((control) => {
        control.addEventListener('click', () => {
          const next = quantities[index] + Number(control.dataset.bundleDelta);
          if (next < 0) return;
          quantities[index] = next;
          bundle.querySelectorAll('[data-bundle-preset]').forEach((preset) => preset.classList.remove('is-active'));
          render();
        });
      });
    });

    bundle.querySelectorAll('[data-bundle-preset]').forEach((control) => {
      control.addEventListener('click', () => {
        quantities = [...presets[control.dataset.bundlePreset]];
        bundle.querySelectorAll('[data-bundle-preset]').forEach((preset) => preset.classList.toggle('is-active', preset === control));
        render();
      });
    });

    button.addEventListener('click', async () => {
      const items = products
        .map((product, index) => ({ id: product.id, quantity: quantities[index] }))
        .filter((item) => item.quantity > 0);
      if (items.reduce((sum, item) => sum + item.quantity, 0) < 4) return;

      button.disabled = true;
      button.textContent = button.dataset.addingLabel;
      if (status) status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('bundle_add_failed');
        window.location.assign(`${window.Shopify.routes.root}discount/ARMA4?redirect=/cart`);
      } catch (error) {
        if (status) status.textContent = button.dataset.errorLabel;
        render();
      }
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["true-header"]) return;
  try {
    
  document.querySelectorAll('.true-mobile-menu').forEach((menu) => {
    if (menu.dataset.menuReady === 'true') return;
    menu.dataset.menuReady = 'true';

    const summary = menu.querySelector('summary');
    const close = menu.querySelector('.true-mobile-menu__close');
    const links = menu.querySelectorAll('a');

    const setMenuState = () => {
      const isOpen = menu.open;
      summary?.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
    };

    menu.addEventListener('toggle', () => {
      setMenuState();
    });

    close?.addEventListener('click', () => {
      menu.open = false;
      summary?.focus();
    });

    links.forEach((link) => {
      link.addEventListener('click', () => {
        menu.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        summary?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["true-product"] && !Shopify.designMode) return;
  try {
    
  if (document.getElementById('PBarNextFrame')) {
    document.documentElement.classList.add('true-theme-preview');
  }

  document.querySelectorAll('.true-product__thumbnail').forEach((button) => {
    button.addEventListener('click', () => {
      const main = document.getElementById('TrueProductMainImage');
      if (!main) return;
      main.src = button.dataset.productImage;
      main.srcset = '';
      main.alt = button.dataset.productAlt || '';
      const zoomImage = document.getElementById('TrueProductZoomImage');
      if (zoomImage) {
        zoomImage.src = button.dataset.productImage;
        zoomImage.srcset = '';
        zoomImage.alt = button.dataset.productAlt || '';
      }
      main.closest('.true-product__main-media')?.classList.toggle('is-photo', button.dataset.productFit === 'cover');
      document.querySelectorAll('.true-product__thumbnail').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    });
  });

  const zoomDialog = document.querySelector('[data-product-zoom]');
  document.querySelector('[data-product-zoom-open]')?.addEventListener('click', () => {
    zoomDialog?.showModal();
  });
  document.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => {
    zoomDialog?.close();
  });
  zoomDialog?.addEventListener('click', (event) => {
    if (event.target === zoomDialog) zoomDialog.close();
  });

  document.querySelectorAll('.true-product-form').forEach((form) => {
    const input = form.querySelector('input[name="quantity"]');
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
